export const CATEGORY_TITLES: Record<string, string> = {
  job_related: 'あなたの仕事についてうかがいます。',
  recent_condition: '最近1か月間のあなたの状態についてうかがいます。',
  social_support: 'あなたの周りの方々についてうかがいます',
  satisfaction: '満足度について',
};

// APIから返ってくるleft_labelの値
export const ANSWER_SCALE = {
  AGREEMENT: 'そうだ',
  FREQUENCY: 'ほとんどなかった',
  INTENSITY: '非常に',
  SATISFACTION: '満足',
} as const;

type AnswerScaleType = (typeof ANSWER_SCALE)[keyof typeof ANSWER_SCALE];

// 各スケールタイプに対応するラベル
export const ANSWER_LABELS: Record<AnswerScaleType, readonly string[]> = {
  [ANSWER_SCALE.AGREEMENT]: ['そうだ', 'まあそうだ', 'ややちがう', 'ちがう'],
  [ANSWER_SCALE.FREQUENCY]: [
    'ほとんどなかった',
    'ときどきあった',
    'しばしばあった',
    'ほとんどいつもあった',
  ],
  [ANSWER_SCALE.INTENSITY]: ['非常に', 'かなり', '多少', '全くない'],
  [ANSWER_SCALE.SATISFACTION]: ['満足', 'まあ満足', 'やや不満足', '不満足'],
} as const;

export const DEFAULT_ANSWER_LABELS = ANSWER_LABELS[ANSWER_SCALE.AGREEMENT];

/**
 * left_labelに基づいて適切な回答ラベルを取得する
 * @param leftLabel APIから返ってくるleft_labelの値
 * @returns 対応する回答ラベルの配列（見つからない場合はデフォルト）
 */
export const getAnswerLabels = (leftLabel: string | undefined): readonly string[] => {
  if (!leftLabel) return DEFAULT_ANSWER_LABELS;
  return ANSWER_LABELS[leftLabel as AnswerScaleType] || DEFAULT_ANSWER_LABELS;
};
